import React, {Component} from "react"

class InlineArticlePush extends Component {

    constructor(props) {
        super(props)
        this.state = {
            url: null
        }
    }

    componentWillMount() {
        const url = this.props.url
        this.setState({url}, () => {
            this.props.proxy.querySelector('.container-inline-article-push').addEventListener('click', (e) => this.articleClick(e))
        })
    }

    articleClick(e) {
        const source = e.target || e.srcElement
        if (!source || !this.state.url) return
        if (source.getAttribute('href') === null || source.getAttribute('href') === '') {
            window.location = this.state.url
        }
    }

    render() {
        return <div></div>
    }
}

export default (InlineArticlePush)


// WEBPACK FOOTER //
// ./vendor/bbs/crt/src/resources/views/components/inline-article-push/InlineArticlePush.js